module.exports = __webpack_public_path__ + "static/media/angle-right.7199a5b7.svg";